export const PAYMENT_ACCOUNT_TYPE = {
	ELEMENT: 0,
	PAYANYWHERE: 1,
	POS: 2,
	AWC: 3,
	PPH: 4,
	CARDCONNECT: 5,
	CLOVER: 6,
	ZETTLE: 7,
	MAGENSA: 8,
} as const;
export type TPaymentAccountType = typeof PAYMENT_ACCOUNT_TYPE[keyof typeof PAYMENT_ACCOUNT_TYPE];
